import { render } from "./EditStudiesPopup.vue?vue&type=template&id=afcb4b04&scoped=true"
import script from "./EditStudiesPopup.vue?vue&type=script&lang=js"
export * from "./EditStudiesPopup.vue?vue&type=script&lang=js"

import "./EditStudiesPopup.vue?vue&type=style&index=0&id=afcb4b04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afcb4b04"]])

export default __exports__